import { FleetSummary } from '../types/Fleetsummary';
import { DeviceEnriched } from '../types/DeviceEnriched';
import { PaginatedResult } from '../types/PaginatedResult';
import { httpGet_New } from './api.service';

export interface FleetSummaryParams {
  filters?: Record<string, unknown>[];
  skip?: number;
  take?: number;
  sortBy?: unknown[];
}

export const getFleetSummary = async (params: FleetSummaryParams = {}): Promise<PaginatedResult<FleetSummary>> => {
  return await httpGet_New<PaginatedResult<FleetSummary>>('api/v2/stock/fleetsummary', params);
};

export const getFleetDevices = async (params: FleetSummaryParams = {}): Promise<PaginatedResult<DeviceEnriched>> => {
  return await httpGet_New<PaginatedResult<DeviceEnriched>>('api/v2/stock/device', params);
};
